import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
// Copyright 1999-2020. Plesk International GmbH. All rights reserved.
import { isRtl } from '../../utils';
import React, { Children } from 'react';
import classNames from 'classnames';
import { CLS_PREFIX } from '../../constants';
import Icon from '../Icon';

/**
 * `Breadcrumbs` component indicates a position of current page in general hierarchy of all pages,
 * and it is used for navigation up to the main page of the product.
 * @since 2.3.0
 */
var Breadcrumbs = function Breadcrumbs(_ref) {
  var _ref$baseClassName = _ref.baseClassName,
      baseClassName = _ref$baseClassName === void 0 ? "".concat(CLS_PREFIX, "breadcrumbs") : _ref$baseClassName,
      className = _ref.className,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["baseClassName", "className", "children"]);

  return React.createElement("nav", _extends({
    role: "navigation",
    "aria-label": "Breadcrumbs",
    className: classNames(baseClassName, className)
  }, props), React.createElement("ul", {
    className: "".concat(baseClassName, "__list")
  }, Children.map(children, function (child) {
    return React.createElement("li", {
      className: "".concat(baseClassName, "__item")
    }, child, React.createElement("span", {
      className: "".concat(baseClassName, "__separator")
    }, React.createElement(Icon, {
      name: isRtl() ? 'chevron-left' : 'chevron-right'
    })));
  })));
};

export default Breadcrumbs;